import { createContext, ReactNode, useContext } from "react";

import { SDBasketType } from "../../db";

import { ContextOrderBasketType } from "../../hooks";

import type { DraftOrdersListResponseType } from "@sellar-io/api-v2/types";

export type SupplierStorefrontInfo = DraftOrdersListResponseType[number];

export type UnifiedCheckoutContextApi = {
  sdBasket: SDBasketType;
  sdOrders: ContextOrderBasketType[];
  supplierInfoMap: Map<number, SupplierStorefrontInfo>;
  isLoading: boolean;
  updateBasket: (_updates: Partial<SDBasketType>) => Promise<void>;
};

export type UnifiedCheckoutProviderProps = {
  sdBasket: SDBasketType;
  sdOrders: ContextOrderBasketType[];
  supplierInfoMap: Map<number, SupplierStorefrontInfo>;
  isLoading: boolean;
  updateBasket: (_updates: Partial<SDBasketType>) => Promise<void>;
  children: ReactNode;
};

export const UnifiedCheckoutContext =
  createContext<UnifiedCheckoutContextApi | null>(null);

export const useUnifiedCheckout = (): UnifiedCheckoutContextApi => {
  const context = useContext(UnifiedCheckoutContext);
  if (!context) {
    throw new Error(
      "useUnifiedCheckout() must be used within <UnifiedCheckoutProvider />",
    );
  }
  return context;
};
